








import Vue from 'vue';
import TheGameWindow from "@/views/TheGameWindow.vue";

export default Vue.extend({
    name: 'App',
    components: {TheGameWindow},
    data: () => ({
        //
    }),
});
